import React, { Component } from "react";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import BannerImg from "../../assets/images/banner/international-acceptance.png";
import { Helmet } from "react-helmet";

class InternationalAcceptance extends Component {
  state = {};
  render() {
    ReactGA.initialize("UA-5235714-2");
    ReactGA.pageview(window.location.pathname + window.location.search);
    return (
      <React.Fragment>
        <Helmet defer={false}>
          <title>International Acceptance | Global Delivery Evidence | Avani Cimcon</title>
          <meta
            name="keywords"
            content="Software Development Services, Web Application Development India, web development testimonials, web development, USA, Europe, Middle East, Asia Pacific."
          />
          <meta
            name="description"
            content="International Acceptance preserves Avani Cimcon's global delivery footprint as enterprise evidence: cross-border implementations, distributed teams, and long-term software delivery across the USA, Europe, Middle East and Asia Pacific."
          />
        </Helmet>

        <div className="page-banner d-flex align-items-center justify-content-center text-white">
          <div className="page-title container position-relative">
            <h1 className="font-weight-bold text-uppercase">International Acceptance</h1>
            <h5>Enterprise delivery evidence across global markets</h5>
          </div>
          <div className="page-banner-img" style={{ backgroundImage: `url("${BannerImg}")` }}></div>
          <div className="page-banner-overlay"></div>
        </div>

        <div className="inner-page mt-5 mb-5 ">
          <div className="container">
            <div className="text-justify">
              <h2 className="text-primary">Enterprise delivery</h2>
              <p>
                International Acceptance is not a customer praise page. It is a compact proof page
                that shows Avani Cimcon has repeatedly delivered software across borders, time
                zones, and operating models.
              </p>
              <p>
                The countries and regions below are evidence of distributed delivery, not the
                story itself. The story is the company’s ability to work with real enterprise
                constraints and sustain relationships over time.
              </p>
            </div>

            <div className="shadow-sm p-4 mt-4">
              <h5 className="text-primary mb-3">Delivery experience</h5>
              <p className="mb-3">
                This experience includes enterprise modernization, platform engineering, workflow
                automation, legacy modernization, integration, distributed systems, multilingual
                systems, cloud migration, enterprise architecture and operational software where
                the context supports it.
              </p>
              <div className="row">
                <div className="col-md-3 mb-3">
                  <strong>Global implementations</strong>
                  <p className="mb-0">Projects delivered across multiple geographies.</p>
                </div>
                <div className="col-md-3 mb-3">
                  <strong>Distributed teams</strong>
                  <p className="mb-0">Offshore delivery aligned with client-side operations.</p>
                </div>
                <div className="col-md-3 mb-3">
                  <strong>Cross-border engineering</strong>
                  <p className="mb-0">Systems designed to work across regions and standards.</p>
                </div>
                <div className="col-md-3 mb-3">
                  <strong>Long-term support</strong>
                  <p className="mb-0">Engagements sustained beyond initial delivery.</p>
                </div>
              </div>
            </div>

            <div className="shadow-sm p-4 mt-4">
              <h5 className="text-primary mb-3">Countries and regions served</h5>
              <table className="table table-bordered mb-0">
                <thead>
                  <tr className="bg-light">
                    <th>USA</th>
                    <th>EUROPE</th>
                    <th>MIDDLE-EAST</th>
                    <th>ASIA-PACIFIC</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <ul className="list-unstyled p-0 m-0">
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          California
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Arkansas
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          New Jersey
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Florida
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Caribbean Islands
                        </li>
                      </ul>
                    </td>

                    <td>
                      <ul className="list-unstyled p-0 m-0">
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          United Kingdom
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Greece
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Germany
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Austria
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          France
                        </li>
                      </ul>
                    </td>

                    <td>
                      <ul className="list-unstyled p-0 m-0">
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          UAE
                        </li>
                      </ul>
                    </td>

                    <td>
                      <ul className="list-unstyled p-0 m-0">
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          India
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Malaysia
                        </li>
                        <li className="d-flex align-items-center mb-2 mt-2">
                          <i className="fa fa-check-circle mr-2 text-primary" aria-hidden="true"></i>
                          Australia
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="shadow-sm p-4 mt-4 text-justify">
              <h5 className="text-primary mb-3">Why this matters</h5>
              <p>
                International delivery experience strengthens trust in modernization work because it
                shows the team can operate across stakeholders, systems and markets without losing
                delivery discipline.
              </p>
              <p className="mb-0">
                Related proof pages:{" "}
                <Link to="/international-projects">International Projects</Link>,{" "}
                <Link to="/domestic-projects">Domestic Projects</Link>,{" "}
                <Link to="/it-consulting-services">IT Consulting Services</Link>, and{" "}
                <Link to="/about">About</Link>.
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default InternationalAcceptance;
